type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const ShowFilesHeader: Header[] = [
  {
    key: 'documentCategory',
    label: 'Document Category',
    style: {width: '14%'},
  },
  {key: 'documentTypeName', label: 'Document Type', style: {width: '14%'}},
  {key: 'fileNameShareRecord', label: 'File Name', style: {width: '14%'}},
  {
    key: 'description',
    label: 'Description',
    style: {width: '14%'},
  },
  {
    key: 'uploadedByName_Date',
    label: 'Uploaded By | On',
    style: {width: '16%'},
  },

  {
    key: 'download',
    label: 'Action',
    style: {textAlign: 'center', width: '7%'},
  },
];

export const ShareByMeHeader: Header[] = [
  // {
  //   key: 'customerAccountNo',
  //   label: 'Patient Account No. | Name',
  //   style: {width: '15%'},
  // },
  {
    key: 'subjectFullName',
    label: 'Patient',
    style: {width: '20%'},
  },
  {
    key: 'sharedWithUserNames',
    label: 'Shared with User',
    style: {width: '15%'},
  },
  {
    key: 'sharedWithEmails',
    label: 'Shared with Email',
    style: {width: '18%'},
  },
  {
    key: 'expiryDateNew',
    label: 'Expiry Date',
    style: {width: '12%'},
  },
  {
    key: 'shareStatus',
    label: 'Status',
    style: {width: '7%'},
  },
  {
    key: 'sharedBy_On',
    label: 'Shared By | On',
    style: {width: '13%'},
  },
  {
    key: 'actions',
    label: 'Action',
    style: {width: '7%'},
  },
];

export const ShareWithMeHeader: Header[] = [
  // {
  //   key: 'customerAccountNo',
  //   label: 'Patient Account No. | Name',
  //   style: {width: '20%'},
  // },
  {
    key: 'subjectFullName',
    label: 'Patient',
    style: {width: '20%'},
  },
  {
    key: 'expiryDateNew',
    label: 'Expiry Date',
    style: {width: '15%'},
  },
  {
    key: 'shareStatus',
    label: 'Status',
    style: {width: '15%'},
  },
  {
    key: 'sharedBy_On',
    label: 'Shared By | On',
    style: {width: '20%'},
  },
  {
    key: 'actions',
    label: 'Action',
    style: {width: '10%'},
  },
];
